import { IImageTickerItem } from '../components/types'
import { whereToBuy_partners_edges } from '../__generated__/whereToBuy'
import { getPropByCode, getPropFileByCode } from './gql'

export const createPartners = (
  data: whereToBuy_partners_edges[],
): IImageTickerItem[] => {
  if (data?.length < 1) {
    return null
  }

  const items: IImageTickerItem[] = data?.map((item) => ({
    id: item?.node?.id,
    img: getPropFileByCode(item.node?.propertyValuesRelation, 'IMAGE'),
    imgMobile: getPropFileByCode(
      item.node?.propertyValuesRelation,
      'IMAGE_MOBILE',
    ),
    link: getPropByCode(item.node?.propertyValues, 'LINK'),
  }))

  return items
}
